import Notification from "./Message";
var Message = {};
var notification = null;
// @ts-ignore
Notification.newInstance({}, function (n) {
  notification = n;
});
var commonOpen = function commonOpen(type) {
  return function (content) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    notification.notice({
      duration: duration,
      severity: type,
      content: content,
      icon: icon
    });
  };
};
['success', 'warning', 'info', 'error'].forEach(function (type) {
  Message[type] = commonOpen(type);
});
export default Message;